export enum ExploreTabEnum {
  ACTIVITIES = 'activities',
  PEOPLE = 'people',
  OPPORTUNITIES = 'opportunities',
  ALUMNI = 'alumni',
  BEHAVIOR = 'behaviors',
  PROJECTS = 'projects',
  PRAISE = 'praise',
  REVIEWS = 'reviews',
  COMPANY_UPDATES = 'company-updates',
  ORGANIZATION_EVENTS = 'events',
  VIDEOS = 'videos',
  // QUICK_LINKS = 'quick-links',
  WIN_LIST = 'win-lists',
  MANAGED_GROUP_VIEW = 'managed-group-view',
}
